import React from 'react';
import {LayoutProps} from '../types';
import {Layout} from '../coreLayout/Layout';
import {BaseLayout} from '../coreLayout';

export const LayoutScrollable: React.FC<LayoutProps> = ({
  children,
  ...props
}) => {
  return (
    <Layout {...props} flex>
      <BaseLayout absolute scrollable>
        {children}
      </BaseLayout>
    </Layout>
  );
};
